import { create } from '@thoughtspot/logger';
import React from 'react';
import ReactDOM from 'react-dom';
import { ChartEventTypes } from '..';
import { BaseChart } from '../common/base-chart';
import { getChartType } from '../core/chart-model-utils';
import { getEnvFlags } from '../env';
import { ChartType } from '../types';
import { drawAnomalyV2 } from './secondary-render-util';
const logger = create('react-chart-logger');
const getComponent = async (chartType) => {
    switch (chartType) {
        case ChartType.Kpi:
            return (await import('../components/kpi/kpi')).KPIChart;
        default:
            return null;
    }
};
export class ReactChart extends BaseChart {
    constructor(chartObj, chartEleContainer, chartModel, dataModel, eventsMap, config, env) {
        super(chartEleContainer, chartModel, env, config);
        this.chartObj = chartObj;
        this.chartEleContainer = chartEleContainer;
        this.chartModel = chartModel;
        this.dataModel = dataModel;
        this.eventsMap = eventsMap;
        this.config = config;
        this.env = env;
        this.componentRef = React.createRef();
        this.highchartRef = React.createRef();
        this.eventsMap = eventsMap;
    }
    getHighchartObj() {
        var _a;
        return (_a = this.highchartRef) === null || _a === void 0 ? void 0 : _a.current;
    }
    hasInternalChartError() {
        return false;
    }
    async render() {
        const Component = await getComponent(getChartType(this.chartModel));
        let resolveRenderComplete;
        const renderCompletePromise = new Promise(resolve => {
            resolveRenderComplete = resolve;
        });
        const handleRenderComplete = () => {
            if (resolveRenderComplete) {
                resolveRenderComplete();
                resolveRenderComplete = undefined;
            }
        };
        ReactDOM.render(React.createElement(Component, { ref: this.componentRef, chartModel: this.chartModel, chartObj: this.chartObj, dataModel: this.dataModel, eventsMap: this.eventsMap, config: this.config, env: this.env, highchartRef: this.highchartRef, onRenderComplete: handleRenderComplete }), this.chartEleContainer);
        await renderCompletePromise;
    }
    secondaryRender() {
        if (getEnvFlags().isKPIWithAnomalyV2Enabled &&
            !this.chartObj.chartOptions.hideAnalyzeButton) {
            drawAnomalyV2(this);
        }
        this.eventsMap.get(ChartEventTypes.RenderComplete)(this.chartModel);
    }
    get hasCustomDownload() {
        return false;
    }
    reflow() {
        logger.debug('KPI reflow has been called.');
        if (getEnvFlags().isKPIWithAnomalyV2Enabled &&
            !this.chartObj.chartOptions.hideAnalyzeButton) {
            drawAnomalyV2(this);
        }
    }
    setScaledFonts(shouldScale) {
        if ((shouldScale || this.chartOptions.shouldScaleFonts) &&
            shouldScale !== this.chartOptions.shouldScaleFonts) {
            this.chartOptions.shouldScaleFonts = shouldScale;
            this.render();
        }
    }
    redraw() {
        logger.debug('Method not implemented.');
    }
    update() {
        logger.debug('Method not implemented.');
    }
    getSelectedPoints() {
        if (this.componentRef &&
            this.componentRef.current &&
            this.componentRef.current.getSelectedPoints) {
            return this.componentRef.current.getSelectedPoints();
        }
        return [];
    }
    setSize(chartWidth, chartHeight, flag) {
        if (this.componentRef &&
            this.componentRef.current &&
            this.componentRef.current.setSize) {
            this.componentRef.current.setSize(chartWidth, chartHeight, flag);
        }
    }
    getRenderOptions() {
        logger.debug('Method not implemented.');
    }
}
export async function chartUIRenderReactComp(chartObj, chartEl, chartModel, dataModel, eventsMap, config, env) {
    const chart = new ReactChart(chartObj, chartEl, chartModel, dataModel, eventsMap, config, env);
    await chart.render();
    return chart;
}
//# sourceMappingURL=index.js.map